import React from "react";
import Parser from "html-react-parser";
import Modal from "../shared/Modal";
import CustomButton from "../shared/CustomButton";
import { CloseMD, t } from "../normalizer";

// Post-submission checkout result modal. Follows the same two-state callout
// pattern used by Profile/Card/Popup.js:
//   success === true  → success alert (backend message); OK navigates away
//   success === false → warning callout (backend error);  OK closes the modal
// The parent owns the OK behaviour via `onOk`.
const CartResultModal = ({ show, success, message, onOk }) => {
  if (!show) return null;

  const title = success
    ? t("gamification2026.cart.result-success-title")
    : t("gamification2026.cart.result-error-title");

  return (
    <Modal show={show} untoggle={onOk} small>
      <div className="gl2026-modal__header noborder">
        <h4 className="gl2026-modal__title">{title}</h4>
        <button
          type="button"
          className="gl2026-modal__close"
          onClick={onOk}
          aria-label="Fechar"
        >
          <CloseMD />
        </button>
      </div>

      <div className="gl2026-modal__body">
        {success ? (
          <div className="gl2026-modal__alert gl2026-modal__alert--success">
            {message ? Parser(message) : t("gamification2026.cart.result-success-title")}
          </div>
        ) : (
          <div className="gl2026-modal__callout gl2026-modal__callout--warning">
            <div className="gl2026-modal__callout-content">
              <p className="gl2026-modal__callout-text">
                {message ? Parser(message) : t("gamification2026.cart.result-error-title")}
              </p>
            </div>
          </div>
        )}
      </div>

      <div className="gl2026-modal__footer">
        <CustomButton type="button" onClick={onOk}>
          OK
        </CustomButton>
      </div>
    </Modal>
  );
};

export default CartResultModal;
